export const convertDateToDDMMYYYY = (dateStr) => {
  const months = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12",
  };

  // Split the input date string
  const [day, month, year] = dateStr.split("-");

  // Convert the month abbreviation to a number
  const monthNumber = months[month];
  // Return the date in dd/mm/yyyy format
  return `${day}/${monthNumber}/${year}`;
};

export const convertDateToDDMMMYYYY = (dateStr) => {
  if (!dateStr) return "";

  // Check if dateStr is in dd-mm-yyyy format
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
    const [day, month, year] = dateStr.split("-");
    const date = new Date(year, month - 1, day); // JS expects yyyy, monthIndex, day

    const monthNames = [
      "Jan","Feb","Mar","Apr","May","Jun",
      "Jul","Aug","Sep","Oct","Nov","Dec"
    ];

    return `${day}-${monthNames[date.getMonth()]}-${year}`;
  }

  // Otherwise, fallback to native parsing (ISO etc.)
  const date = new Date(dateStr);
  if (isNaN(date)) return "";

  const day = date.getDate().toString().padStart(2, "0");
  const monthNames = [
    "Jan","Feb","Mar","Apr","May","Jun",
    "Jul","Aug","Sep","Oct","Nov","Dec"
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const convertDateToDDMMYYYYLo = (dateStr) => {
  if (!dateStr) return "";

  // Check if dateStr is in dd-mm-yyyy format
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
    const [day, month, year] = dateStr.split("-");
    const date = new Date(year, month - 1, day); // JS expects yyyy, monthIndex, day
    return `${day}-${date.getMonth()}-${year}`;
  }

  // Otherwise, fallback to native parsing (ISO etc.)
  const date = new Date(dateStr);
  if (isNaN(date)) return "";

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.getMonth().padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const convertDateToDDMMMYYYYLetter = (date) => {
  const dates = new Date(date);
  const day = dates.getDate().toString().padStart(2, "0"); // Get day and ensure 2 digits
  const month = (dates.getMonth() + 1).toString().padStart(2, "0"); // Get month as uppercase 3-letter abbreviation
  const year = dates.getFullYear(); // Get full year

  return `${day}/${month}/${year}`;
};

export const convertDateToDDMMYYYYStartWithYear = (dateStr) => {
  // Split the input date string
  const [year, month, day] = dateStr?.split("-");
  // Return the date in dd/mm/yyyy format
  return `${day}/${month}/${year}`;
};

export const currentDate = () => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const now = new Date();

  const day = now.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
  const month = months[now.getMonth()]; // Get the abbreviated month name
  const year = now.getFullYear();

  return `${day}-${month}-${year}`;
};

export const fullDate = (date) => {
  const utcDate = new Date(date);

  // Convert to IST
  const istOffset = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
  const istDate = new Date(utcDate.getTime() + istOffset);

  // Format to dd/mm/yyyy
  const formattedDate = `${String(istDate.getDate()).padStart(2, "0")}/${String(
    istDate.getMonth() + 1
  ).padStart(2, "0")}/${istDate.getFullYear()}`;
  return formattedDate;
};
